// import WebSocketController from './controller';
// import CApiWebSocketService from '../CApiWebSocket/CApiWebSocketService';

// export default (() => {
//   let instance;
//   return {
//     getInstance: (url, connectCallback, disconnectCallback, options, apiKey, deviceExternalId, subscriber) => {
//       if ((instance == null || !instance.connected) && !url?.includes('capi')) {
//         instance = new WebSocketController(url, connectCallback, disconnectCallback, options);
//         // Hide the constructor so the returned object can't be new'd...
//         instance.constructor = null;
//       } else if ((instance == null || !instance.connected)) {
//         instance = new CApiWebSocketService();
//         instance.connect(url, apiKey, deviceExternalId, subscriber);
//         instance.constructor = null;
//       }
//       return instance;
//     }
//   };
// })();
import WebSocketController from './controller';
import CApiWebSocketService from '../CApiWebSocket/CApiWebSocketService';

export default (() => {
  let instance;
  return {
    getInstance: (url, connectCallback, disconnectCallback, options, apiKey, deviceExternalId, storeId, deviceTypeId, logCapiClientHealthInfo, subscriber) => {
      if ((instance == null || !instance.connected) && url && url.includes('yapi')) {
        instance = new WebSocketController(url, connectCallback, disconnectCallback, options);
        // Hide the constructor so the returned object can't be new'd...
        instance.constructor = null;
      } else if ((instance == null || !instance.connected) && url && !url?.includes('yapi')) {
        instance = new CApiWebSocketService();
        instance.connect(url, apiKey, deviceExternalId, storeId, deviceTypeId, logCapiClientHealthInfo, subscriber);
        instance.constructor = null;
      }
      return instance;
    }
  };
})();
